/*
 * Nav popup forms (HubSpot).
 * Buttons carrying [data-nav-popup-open="<blockId>"] open the matching
 * modal (#nav-popup-<blockId>). The HubSpot form is embedded lazily the
 * first time its modal opens. Delegated once at the document level.
 */
(function () {
  if (window.__navPopupInit) return;
  window.__navPopupInit = true;

  function log() {
    try {
      console.log.apply(console, ['[nav-popup]'].concat([].slice.call(arguments)));
    } catch (e) {}
  }
  log('script loaded');

  // The header sits in a z-40 stacking context, which traps these fixed modals
  // beneath the mobile drawer (z-50). Move them to <body> so their z-index is
  // measured at the top level and they can open above the drawer.
  function liftModals() {
    var modals = document.querySelectorAll('.nav-popup');
    for (var k = 0; k < modals.length; k++) {
      if (modals[k].parentNode !== document.body) document.body.appendChild(modals[k]);
    }
    log('lifted modals to body:', modals.length);
  }
  if (document.body) {
    liftModals();
  } else {
    document.addEventListener('DOMContentLoaded', liftModals);
  }

  var hsLoading = false;
  var hsReady = false;
  var pending = [];

  function loadHubSpot(cb) {
    if (hsReady) {
      cb();
      return;
    }
    pending.push(cb);
    if (hsLoading) return;
    hsLoading = true;
    var script = document.createElement('script');
    script.src = 'https://js.hsforms.net/forms/embed/v2.js';
    script.async = true;
    script.onload = function () {
      hsReady = true;
      pending.forEach(function (fn) {
        fn();
      });
      pending = [];
    };
    document.head.appendChild(script);
  }

  function createForm(container) {
    log('createForm ->', container ? 'container ok' : 'NO container', container && container.getAttribute('data-hs-created') ? '(already created)' : '');
    if (!container || container.getAttribute('data-hs-created')) return;
    var portal = container.getAttribute('data-hs-portal');
    var form = container.getAttribute('data-hs-form');
    var region = container.getAttribute('data-hs-region') || 'na1';
    var targetId = container.getAttribute('data-hs-target');
    var target = document.getElementById(targetId);

    if (!portal || !form) {
      if (target) {
        target.innerHTML =
          '<p class="nav-popup__message">This form isn\'t connected yet.</p>';
      }
      container.setAttribute('data-hs-created', '1');
      return;
    }

    container.setAttribute('data-hs-created', '1');

    function removeLoader() {
      var loader = target && target.querySelector('.nav-popup__loading');
      if (loader) loader.remove();
    }

    if (target && !target.innerHTML) {
      target.innerHTML =
        '<div class="nav-popup__loading" aria-hidden="true">Loading\u2026</div>';
      // These forms render into their own node inside the target and do NOT
      // fire onFormReady reliably, so clear the placeholder as soon as any
      // form node appears. Timeout is a final safety net.
      if ('MutationObserver' in window) {
        var obs = new MutationObserver(function (mutations) {
          for (var i = 0; i < mutations.length; i++) {
            var nodes = mutations[i].addedNodes;
            for (var j = 0; j < nodes.length; j++) {
              var node = nodes[j];
              if (
                node.nodeType === 1 &&
                !node.classList.contains('nav-popup__loading')
              ) {
                removeLoader();
                obs.disconnect();
                return;
              }
            }
          }
        });
        obs.observe(target, { childList: true });
      }
      setTimeout(removeLoader, 10000);
    }

    loadHubSpot(function () {
      if (!window.hbspt || !window.hbspt.forms) return;
      window.hbspt.forms.create({
        portalId: portal,
        formId: form,
        region: region,
        target: '#' + targetId,
        onFormReady: removeLoader
      });
    });
  }

  var lastFocus = null;

  function openPopupModal(modal) {
    log('openPopupModal ->', modal ? modal.id || modal : 'NULL (modal not found)');
    if (!modal) return;
    if (modal.hidden === false) { log('already open, skipping'); return; }
    lastFocus = document.activeElement;
    modal.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    createForm(modal.querySelector('[data-hs-portal]'));
    var dialog = modal.querySelector('.nav-popup__dialog');
    if (dialog) dialog.focus();
  }

  function openPopup(id) {
    log('openPopup id =', id, '| found:', !!document.getElementById('nav-popup-' + id));
    openPopupModal(document.getElementById('nav-popup-' + id));
  }

  function openPopupByKey(key) {
    log('openPopupByKey key =', key);
    if (!key) return;
    var safe = window.CSS && CSS.escape ? CSS.escape(key) : key;
    openPopupModal(document.querySelector('[data-nav-popup-key="' + safe + '"]'));
  }

  // Exposed so callers that can't rely on the delegated click (e.g. links inside
  // the teleported mobile drawer, which swallows the bubbling click) can open directly.
  window.__navPopupOpen = openPopup;
  window.__navPopupOpenByKey = openPopupByKey;

  function closePopup(modal) {
    if (!modal) return;
    modal.hidden = true;
    document.documentElement.style.overflow = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  // Pre-load the form when the user shows intent (hover / focus / touch),
  // so it is ready — or nearly — by the time they actually click.
  function warm(opener) {
    var modal;
    if (opener.hasAttribute('data-nav-popup-open')) {
      modal = document.getElementById(
        'nav-popup-' + opener.getAttribute('data-nav-popup-open')
      );
    } else {
      var key = opener.getAttribute('data-nav-popup-open-key');
      var safe = window.CSS && CSS.escape ? CSS.escape(key) : key;
      modal = document.querySelector('[data-nav-popup-key="' + safe + '"]');
    }
    if (modal) createForm(modal.querySelector('[data-hs-portal]'));
  }

  function onWarmEvent(event) {
    if (!event.target || !event.target.closest) return;
    var opener = event.target.closest(
      '[data-nav-popup-open], [data-nav-popup-open-key]'
    );
    if (opener) {
      log('warm intent (' + event.type + ') on', opener.getAttribute('data-nav-popup-open') || opener.getAttribute('data-nav-popup-open-key'));
      warm(opener);
    }
  }
  document.addEventListener('pointerover', onWarmEvent);
  document.addEventListener('focusin', onWarmEvent);
  document.addEventListener('touchstart', onWarmEvent, { passive: true });

  document.addEventListener('click', function (event) {
    var t = event.target;
    log('document click on', t && t.tagName, t && t.className, '| closest opener:', t && t.closest ? !!t.closest('[data-nav-popup-open],[data-nav-popup-open-key]') : 'no closest');
    // Links written as <a href="#popup-<key>"> (e.g. in rich text / FAQ answers)
    // open the matching popup. href survives rich-text sanitization, unlike
    // data-* attributes, so this is the safe way to trigger from body content.
    var hashOpener = event.target.closest('a[href*="#popup-"]');
    if (hashOpener) {
      var hp = hashOpener.getAttribute('href') || '';
      var hidx = hp.indexOf('#popup-');
      if (hidx !== -1) {
        event.preventDefault();
        openPopupByKey(hp.slice(hidx + 7));
        return;
      }
    }
    var opener = event.target.closest('[data-nav-popup-open]');
    if (opener) {
      event.preventDefault();
      openPopup(opener.getAttribute('data-nav-popup-open'));
      return;
    }
    var openerKey = event.target.closest('[data-nav-popup-open-key]');
    if (openerKey) {
      event.preventDefault();
      openPopupByKey(openerKey.getAttribute('data-nav-popup-open-key'));
      return;
    }
    var closer = event.target.closest('[data-nav-popup-close]');
    if (closer) {
      event.preventDefault();
      closePopup(closer.closest('[data-nav-popup]'));
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    var open = document.querySelector('[data-nav-popup]:not([hidden])');
    if (open) closePopup(open);
  });
})();
